import { useMemo } from 'react';

import useProjectDashboardHubConnection from 'features/projects/dashboard/hooks/useProjectDashboardHubConnection';
import DashboardGaugeChartsContainer from 'features/projects/dashboard/components/charts/DashboardGaugeChartsContainer';
import DashboardWellboreTrajectoryContainer from 'features/projects/dashboard/components/dashboards/DashboardWellboreTrajectoryContainer';
import ProjectExecutionStatusContainer from 'features/projects/dashboard/components/ProjectExecutionStatusContainer/ProjectExecutionStatusContainer';

const WinchWellboreAndGaugeDashboardController = ({
  projectId,
  renderSlots,
  projectDashboardId,
}) => {
  const { curves, registerDataPointsHandler } =
    useProjectDashboardHubConnection(projectId, projectDashboardId);

  const depthCurve = useMemo(
    () => curves.find((curve) => curve.get('isDepth')),
    [curves],
  );

  return renderSlots(
    <DashboardWellboreTrajectoryContainer
      curve={depthCurve}
      projectId={projectId}
      registerDataPointsHandler={registerDataPointsHandler}
    />,
    <DashboardGaugeChartsContainer
      curves={curves}
      projectId={projectId}
      registerDataPointsHandler={registerDataPointsHandler}
    />,
    <ProjectExecutionStatusContainer projectId={projectId} />,
  );
};

export default WinchWellboreAndGaugeDashboardController;
